import type { JobStatus } from '@chukua/common';

/** Tag colour and label for a job's status — moved only through `job-state.policy.ts`'s manual actions or dispatch/tracking's domain events, never editable here. */
export const JOB_STATUS_LABELS: Record<JobStatus, string> = {
  enquiry: 'Enquiry',
  quoted: 'Quoted',
  confirmed: 'Confirmed',
  planned: 'Planned',
  in_progress: 'In progress',
  delivered: 'Delivered',
  closed: 'Closed',
  on_hold: 'On hold',
  cancelled: 'Cancelled',
};

export const JOB_STATUS_COLORS: Record<JobStatus, string> = {
  enquiry: 'default',
  quoted: 'processing',
  confirmed: 'processing',
  planned: 'processing',
  in_progress: 'processing',
  delivered: 'success',
  closed: 'default',
  on_hold: 'warning',
  cancelled: 'error',
};
